import React, { useState } from "react";
import { quicklink } from "./quickLinks";
import { useNavigate } from "react-router-dom";
import { MdKeyboardArrowDown } from "react-icons/md";
import { createSubscribersAPI } from "../../serverApi/server";

const LinkandMail = () => {
  const [subsData, setSubsData] = useState({
    name: "",
    mail: "",
  });

  const [subscribed, setSubscribed] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSubsData((prevData) => ({
      ...prevData,
      [name]:
        name === "name"
          ? value.replace(/\s{2,}/g, " ")
          : value.replace(/\s+/g, ""),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await createSubscribersAPI(
        subsData.firstName,
        subsData.lastName,
        subsData.mail
      );
      if (response.data.client_status_code === 200) {
        setSubscribed(true);
      }
    } catch (error) {
      console.error('Error creating Subscribers:',error);
    }
  };

  const navigate = useNavigate();
  const navigateLink = (path) => {
    navigate(path)
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      <div className="sm:mb-5">
        <h5 className="text-2xl font-bold mb-4">Quick Links</h5>
        <div className="flex flex-col space-y-1 sm:space-y-2">
          {quicklink.map((link) => {
            return (
              <div key={link.id} onClick={() => navigateLink(link.path)} className="flex items-center hover:underline">
                <MdKeyboardArrowDown className="-rotate-90 mr-1 text-black" />
                <div key={link.id} className="text-gray-700 cursor-pointer">
                  {link.title}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="mb-5">
        <h5 className="text-2xl mb-4 font-bold">Newsletter</h5>
        { !subscribed && (<form onSubmit={handleSubmit}>
          <div className="flex gap-2 mb-4">
            <input
              value={subsData.firstName}
              name="firstName"
              onChange={handleChange}
              type="text"
              className="border-0 py-2 px-3 w-1/2"
              placeholder="First Name"
              required
            />
            <input
              value={subsData.lastName}
              name="lastName"
              onChange={handleChange}
              type="text"
              className="border-0 py-2 px-3 w-1/2"
              placeholder="Last Name"
              required
            />
          </div>

          <input
            value={subsData.mail}
            name="mail"
            onChange={handleChange}
            type="email"
            className="border-0 py-2 px-3 mb-4 w-full"
            placeholder="Your Email"
            required
          />
          <button className="bg-white hover:bg-orange-300 transition-all duration-200 py-2 w-full">
            Subscribe Now
          </button>
        </form>
        )}
        { subscribed && (
          <p className="bg-orange-300 py-3 text-center w-full">
          Subscribed
        </p>
        )}
      </div>
    </div>
  );
};

export default LinkandMail;
